import { Directive, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { BadgeStatusEnum } from 'src/app/constants/badge-status.enum';
import { ActorStatusEnum, ActorStatusInformationModel } from 'src/app/models/api/actor-status-information.model';
import { TableColumn } from 'src/app/models/tableColumn';
import { RequestStatusService } from '../../requeststatus/requeststatus.service';
import { Subscription } from 'rxjs';
import { RequestStatusActionsEnum } from 'src/app/constants/RequestStatusActions.enum';
import { VerifyRequestActionService } from 'src/app/services/verify-request-action.service';
import { StatusRequestModel } from 'src/app/models/status/status-request.model';
import { StatusDocumentModel } from 'src/app/models/status/status-document.model';
import { RequestActionTypeEnum } from 'src/app/constants/request-action-type.enum';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RequestTypeEnum } from 'src/app/constants/request-type.enum';
import { RequestStatuses, StatusEnum } from 'src/app/constants/status.enum';
import { DocumentTypeEnum } from 'src/app/constants/document-type.enum';

@Directive()

export class BaseTableClass implements OnDestroy {
  public allowedToDoAction() {
    return this.downloadAllowed() || (this.exportAllowed() && this.showMSplugins);
  }

  downloadAllowed() {
    // no status is checked for download, just whether you are allowed
    return this.verifyRequestActionService.IsAllowed(this.request, RequestActionTypeEnum.Download);
  }

  exportAllowed() {
    // no status is checked for export, just whether you are allowed
    return this.verifyRequestActionService.IsAllowed(this.request, RequestActionTypeEnum.Export);
  }

  requestStatusActionsEnum = RequestStatusActionsEnum;
  @Input() tableData: any[] = [];
  protected _displayedColumns: TableColumn[] = [];
  public columnsToDisplay: string[] = [];
  @Input() set displayedColumns(columns: TableColumn[]) {
    this._displayedColumns = columns;
  }
  get displayedColumns(): TableColumn[] {
    this.columnsToDisplay = this._displayedColumns.map((s: TableColumn) => s.columnName);
    return this._displayedColumns;
  }

  protected request!: StatusRequestModel;
  protected requestGuid!: string;
  protected requestSubscription: Subscription | null = null;
  protected usersubscription: Subscription | null = null;
  protected showMSplugins: boolean = false;

  constructor(protected requestStatusService: RequestStatusService, protected verifyRequestActionService: VerifyRequestActionService, protected authenticationService: AuthenticationService) {
    this.requestSubscription = this.requestStatusService.selectedRequest$.subscribe(request => {
      this.request = request;
      this.requestGuid = request.id;
    })    
    this.usersubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.showMSplugins = data.aMsPluginIsEnabled;
    });
  }

  ngOnDestroy(): void {
    if(this.requestSubscription){
      this.requestSubscription.unsubscribe();
    }
    if(this.usersubscription){
      this.usersubscription.unsubscribe();
    }
  }
 
  public isActionAllowed() {
    let actionsAvailable = this.displayedColumns.findIndex(s => s.columnName === 'actions');
    return (actionsAvailable > -1);
  }

  public isPossibleToViewRendering(document: StatusDocumentModel){
    return document.documentType !== DocumentTypeEnum.UnrenderedFile &&  document.documentType !== DocumentTypeEnum.RegularXml;
  }

  public performActionForAnId(actionName: RequestStatusActionsEnum, actor: ActorStatusInformationModel | null = null, documentId: string | null = '') {
    switch (actionName) {
      case RequestStatusActionsEnum.editPerson:
        this.requestStatusService.getRightActor(actor!.inviteId);
        this.requestStatusService.editPerson(actor!);
        break;
      case RequestStatusActionsEnum.changeDeadline:
        this.requestStatusService.getRightActor(actor!.inviteId);
        // this.requestStatusService.changeDeadline();
        break;
      case RequestStatusActionsEnum.changeDeadlineDays:
        this.requestStatusService.getRightActor(actor!.inviteId);
        // this.requestStatusService.changeDeadlineDays();
        break;
      case RequestStatusActionsEnum.resendRequest:
        this.requestStatusService.getRightActor(actor!.inviteId);
        this.requestStatusService.resendRequestInviteForActor(actor!);
        break;
      case RequestStatusActionsEnum.openPreview:
        if(this.request.documentInfo.findIndex(document => document.id === documentId) > -1){
          let document = this.request.documentInfo[this.request.documentInfo.findIndex(document => document.id === documentId)]; 
          this.requestStatusService.openPreview(document);
        }
        break;
      case RequestStatusActionsEnum.showDocumentDetails:
        if(this.request.documentInfo.findIndex(document => document.id === documentId) > -1){
          let document = this.request.documentInfo[this.request.documentInfo.findIndex(document => document.id === documentId)]; 
          this.requestStatusService.OpenDocumentDetais(document);
        }
        break;
      case RequestStatusActionsEnum.Download:
        this.requestStatusService.downloadRequest(this.requestGuid);
        break;
      case RequestStatusActionsEnum.Export:
        this.requestStatusService.exportRequest(this.requestGuid, this.request.requestName);
        break;
      case RequestStatusActionsEnum.DownloadDocument:
        if(this.request.documentInfo.findIndex(document => document.id === documentId) > -1){
          let document = this.request.documentInfo[this.request.documentInfo.findIndex(document => document.id === documentId)]; 
          this.requestStatusService.downloadDocument(this.requestGuid, document);
        }
        break;
      case RequestStatusActionsEnum.ExportDocument:
        if(this.request.documentInfo.findIndex(document => document.id === documentId) > -1){
          let document = this.request.documentInfo[this.request.documentInfo.findIndex(document => document.id === documentId)]; 
          this.requestStatusService.exportDocument(this.requestGuid, document);
        }
        break;
      case RequestStatusActionsEnum.EditFilingData:
        this.requestStatusService.editFilingData();
        break;
      default:
        break;
    }
  }

  // change function if data connected
  public convertedStatusToBadgeStatus(status: string): BadgeStatusEnum {
    if (!status) {
      return BadgeStatusEnum.Info;
    }
    switch (status) {
      case ActorStatusEnum.Waiting:
        return BadgeStatusEnum.Info;
      case ActorStatusEnum.Completed:
        return BadgeStatusEnum.Success;
      case ActorStatusEnum.Pending:
        return BadgeStatusEnum.Warning;
      case ActorStatusEnum.Error:
      case ActorStatusEnum.TriggeredSpecialStatus:
        return BadgeStatusEnum.Danger;
      // As default (primary)/info
      default:
        return BadgeStatusEnum.Info
    }
  }

  copyToClipboard(Guid: string) {
    this.requestStatusService.copyToClipboard(Guid);
  }

  openPreviewAllowed(){
    return this.verifyRequestActionService.IsAllowed(this.request, RequestActionTypeEnum.ShowDocument);
  }

  editFilingDataAllowed(){
    return this.request.requestType === RequestTypeEnum.FileInlineXbrl && 
           RequestStatuses.ThatAreActorPending.includes(this.request.currentStatus as StatusEnum) &&
           this.verifyRequestActionService.IsAllowed(this.request, RequestActionTypeEnum.EditFilingData);
  }
}

